import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TenantService } from './modules/core/services/tenant.service';
import { AuthService } from './modules/auth/_services/auth.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'innovation-center';

  constructor(
    private tenantService: TenantService,
    private authService: AuthService,
    private translate: TranslateService
  ) {
    // Initialize translation service
    this.initializeTranslation();
    
    if (!authService.isAdminOrOperator) {
      let tenants = JSON.parse(localStorage.getItem('tenants') as string);
      if (tenants?.length) {
        let tenant = tenants[0];
        this.authService.changeTenant(tenant);
      }
    }
  }

  private initializeTranslation() {
    // Set available languages
    this.translate.addLangs(['en', 'fr']);
    
    // Set default language
    this.translate.setDefaultLang('en');
    
    // Try to get saved language from localStorage, otherwise use browser language or default
    const savedLanguage = localStorage.getItem('selectedLanguage');
    const browserLang = this.translate.getBrowserLang();
    const languageToUse = savedLanguage || (browserLang?.match(/en|fr/) ? browserLang : 'en');
    
    this.translate.use(languageToUse);
  }
}
